import React from "react";
import styled from "styled-components";
import { style } from "../style";
import { Icon } from "../Icon";
import { ItemizedSummaryNoteItem } from "./types";

const NoteContent = styled.div<{ $type: "info" | "error" | "warning" | "success" }>`
  display: flex;
  align-items: start;
  gap: ${style.vars.space[2]};

  font-size: ${style.vars.fontSize.base};
  color: ${style.colors.grey.darkest};

  ${(props) => {
    if (props.$type === "error") {
      return {
        borderRadius: style.vars.borderRadius.base,
        background: style.colors.red.lightest,
        padding: style.vars.space[1],
      };
    }
  }}
`;

const NoteIconWrapper = styled.div`
  min-width: 24px;
`;

export type NoteProps = {
  item: ItemizedSummaryNoteItem;
  compact?: boolean;
};

export const ItemizedSummaryNote: React.FC<NoteProps> = (props) => {
  const { item } = props;
  const { type = "error" } = item;

  return (
    <NoteContent $type={type}>
      <NoteIconWrapper>
        <Icon large icon={`alert-${type}`} />
      </NoteIconWrapper>
      <div>{item.content}</div>
    </NoteContent>
  );
};
